// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"251":"31d78b82","286":"f5a933cd"}[chunkId] + ".chunk.css";
};